import { atom } from 'recoil';

export const financeState = atom({
  key: 'finance',
  default: {
    dealerRef: '',
    dealerFloor: undefined as undefined | string,
    vehicleImage: '',
    price: 0,
    mmCode: '',
    used: false,
    year: undefined as undefined | number,
    make: undefined as undefined | string,
    model: undefined as undefined | string,
    variant: undefined as undefined | string,
    mileage: '0',
    region: undefined as undefined | string,
    transmission: undefined as undefined | string
  },
});
